import React from 'react';
import './About.css';

const About = () => {
  const skills = [
    { name: 'Java', level: 95 },
    { name: 'Spring Boot', level: 90 },
    { name: 'Microservices', level: 80 },
    { name: 'Hibernate/JPA', level: 90 },
    { name: 'RestFul Webservices', level: 85 },
    { name: 'SQL', level: 90 },
  ];

  const techStack = [
    'Java', 'Spring Boot', 'Microservices', 'Hibernate',
    'JPA', 'REST APIs', 'Spring Cloud', 'Maven', 'Gradle', 'MySQL', 'PostgreSQL', 'Cassandra',
    'Git', 'Design Patterns', 'Data Structures', 'Prompt Engineering'
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p className="about-bio">
              I'm a passionate software engineer with 5 years of experience 
              building scalable, secure, and high-performance backend systems using 
              Java and Spring Boot. I specialize in developing robust microservices 
              architectures and enterprise-level applications.
            </p>
            <p className="about-bio">
              My expertise includes designing and implementing RESTful APIs, working 
              with various databases, applying design patterns, and solving complex 
              algorithmic problems. I'm always eager to learn new technologies and 
              contribute to meaningful projects.
            </p>
            <div className="about-info-section">
              <div className="info-item">
                <svg viewBox="0 0 24 24" fill="currentColor" className="info-icon">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
                <a href="mailto:mansimisal88@gmail.com" className="info-link">mansimisal88@gmail.com</a>
              </div>
              <div className="info-item">
                <svg viewBox="0 0 24 24" fill="currentColor" className="info-icon">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                </svg>
                <span className="info-text">India</span>
              </div>
              <div className="info-item">
                <svg viewBox="0 0 24 24" fill="currentColor" className="info-icon">
                  <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
                </svg>
                <span className="info-text">Bachelor of Engineering (B.E.) in Computer Science</span>
              </div>
            </div>
            <div className="about-actions">
              <div className="social-actions">
                <a
                  href="https://github.com/mansimm"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-action-btn"
                  aria-label="GitHub profile"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                  </svg>
                </a>
                <a
                  href="https://linkedin.com/in/mansi-misal"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-action-btn"
                  aria-label="LinkedIn profile"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
              <a
                href="/resume/Mansi_Misal_Resume.pdf"
                download="Mansi_Misal_Resume.pdf"
                className="download-resume-btn"
              >
                Download Resume
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                </svg>
              </a>
            </div>
          </div>
          <div className="about-skills">
            <h3 className="skills-title">Skills</h3>
            <div className="skills-list">
              {skills.map((skill, index) => (
                <div key={index} className="skill-item">
                  <div className="skill-header">
                    <span className="skill-name">{skill.name}</span>
                    <span className="skill-percentage">{skill.level}%</span>
                  </div>
                  <div className="skill-bar">
                    <div
                      className="skill-progress"
                      style={{ width: `${skill.level}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="tech-stack">
          <h3 className="tech-stack-title">Tech Stack</h3>
          <div className="tech-tags">
            {techStack.map((tech, index) => (
              <span key={index} className="tech-tag">
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

